import React from 'react'
import { withPage } from '@sms/plasma-ui';
import IFrameComponent from '../../../components/IFramePage/IFrameComponent';

export interface WebgeePageProps {
  children?: React.ReactNode;
  relativePath: string;
}

const WebgeePage = (props: WebgeePageProps) => {
  const { relativePath } = props;

  const envVars: Record<string, unknown> = typeof window === "undefined" ? process.env
  : (window as any).plasma.environment

  return (
    <>
      <div style={{ height: '100%', width: '100%' }}>
        <IFrameComponent key={'iframe-webgee'} option={relativePath} elementId='iframe-webgee' source={envVars.WEBGEE_IFRAME_URL} needsReload={false}/>
      </div>
    </>
  )
}

export default withPage(WebgeePage);
